import { parse } from 'content-disposition-header';
import { HttpResponse } from '@angular/common/http';
import { FailureDescription } from "../modules/go/model/form.model";

export const getFileNameFromHeaders = (response: HttpResponse<Blob>): string => {
  return parse(response.headers.get('content-disposition')!).parameters.filename;
}

export const sortFailuresByCreatedOn = (
  items: FailureDescription[],
  direction: 'asc' | 'desc' = 'desc'
): FailureDescription[] => {
  return items.sort((a, b) =>
    direction === 'asc'
      ? new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime()
      : new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
  );
}
